export default "__VITE_ASSET__WMp9_iOV__"